<template>
  <v-card>
    <v-card-title primary-title class="warning lighten-2">
      {{ label }}
    </v-card-title>
    <v-card-text class="pt-2">
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-center" rowspan="2">
                ระดับการศึกษา Education Level
              </th>
              <th class="text-center" colspan="2">ระยะเวลา Period</th>
              <th class="text-center" rowspan="2">
                ชื่อสถานศึกษาและที่ตั้ง Institus / Place
              </th>
              <th class="text-center" rowspan="2">สาขาวิชา Major</th>
            </tr>
            <tr>
              <th class="text-center">ตั้งแต่ From</th>
              <th class="text-center">ถึง To</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, i) in listEdu" :key="i">
              <td>{{ item.edl_name }}</td>
              <td>
                <v-select
                  label="ปีเริ่มศึกษา"
                  :items="$store.getters.get_ListYear"
                  item-text="yearStr"
                  item-value="yearStr"
                  v-model="item.edu_startyear"
                ></v-select>
              </td>
              <td>
                <v-select
                  label="ปีสำเร็จการศึกษา"
                  :items="$store.getters.get_ListYear"
                  item-text="yearStr"
                  item-value="yearStr"
                  v-model="item.edu_endyear"
                ></v-select>
              </td>
              <td>
                <v-text-field
                  label="ชื่อสถานศึกษาและที่ตั้ง Institus / Place"
                  v-model="item.edu_oldschool"
                ></v-text-field>
              </td>
              <td>
                <v-text-field
                  label="สาขาวิชา Major"
                  v-model="item.edu_major"
                ></v-text-field>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
      <!-- {{listEdu}} -->
    </v-card-text>
  </v-card>
</template>
<script>
// import datetimepicker_TH from "./datetimepickerTH";
export default {
  data() {
    return {
      listEdu:this.$store.getters.get_Educate_Level
    };
  },
  components: {
    // datetimepicker_TH,
  },
  props: {
    label: {
      type: String,
      default: "",
    },
  },
};
</script>
<style scoped>
.v-simple-table {
  border: thin;
}
</style>
